import darkTheme from "./darkTheme";
import lightTheme from "./lightTheme";

// Theme configuration constants
export const THEME_TYPES = {
    LIGHT: 'light',
    DARK: 'dark'
};

export const THEME_CONFIG = {
    admin: THEME_TYPES.DARK,    // Admin uses dark theme
    user: THEME_TYPES.LIGHT     // Users use light theme
};

// Helper function to get theme by type
export const getThemeByType = (themeType) => {
    switch (themeType) {
        case THEME_TYPES.DARK:
            return darkTheme;
        case THEME_TYPES.LIGHT:
        default:
            return lightTheme;
    }
};